<template>
    <div class="table-action-buttons">
        <i v-if="$can('view-faq')" class="fa fa-eye fa-lg pointer" @click="view" :title="uLang('app.show_type', { type: lang('app.question') })"></i>
        <i v-if="$can('update-faq')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.question') })"></i>
        <i v-if="$can('delete-faq')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.question') })"></i>
    </div>
</template>

<script>
    import { DestroyAlert, WarningAlert, SuccessAlert } from "~/Swals";

    export default {
        name: 'actions',
        props: ['data', 'index'],
        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.question') }).show().then(async () => {
                    this.destroy()
                });
            },

            edit() {
                this.$router.push({ name: 'admin.faq.edit', params: { id: this.data.id }})
            },

            view() {
                this.$router.push({ name: 'admin.faq.view', params: { id: this.data.id }})
            },

            async destroy() {
                window.axios.delete('/api/admin/faqs/' + this.data.id).then(() => {
                    new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.question') })}).show();
                    vue.$emit('reloadTable');
                }).catch(({ response }) => {
                    new WarningAlert({text: response.data.errors.status }).show();
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
